import { SiteHeader, SiteFooter } from "./SiteLayout";
import { useSiteContent } from "./siteContent";
import SiteSections from "./SiteSections";

export default function SiteGallery() {
  const site = useSiteContent();
  return (
    <div className="site-font bg-[#0B0F14]" data-testid="site-gallery">
      <SiteHeader />
      <SiteSections sections={site.page_sections.gallery} services={site.services_catalog} contact={site.contact_info} />
      <SiteFooter />
    </div>
  );
}
